import React, { useEffect, useState } from "react";

import { fetchAdminAuditLogs, fetchProjectFundLedger, fetchProjectTreasuryReport } from "../services/adminService";

export default function AdminOperationsPage() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [fundLedger, setFundLedger] = useState([]);
  const [treasuryReport, setTreasuryReport] = useState(null);
  const [projectId, setProjectId] = useState("");
  const [message, setMessage] = useState("");
  const [auditSearch, setAuditSearch] = useState("");

  const load = async () => {
    const logsRes = await fetchAdminAuditLogs();
    setAuditLogs(logsRes.data);
  };

  useEffect(() => {
    load().catch(() => setMessage("Failed to load admin operations data."));
  }, []);

  const onLoadFundLedger = async (e) => {
    e.preventDefault();
    try {
      const { data } = await fetchProjectFundLedger(projectId);
      setFundLedger(data);
      setMessage("");
    } catch (err) {
      setFundLedger([]);
      setMessage(err.response?.data?.detail || "Failed to load fund ledger.");
    }
  };

  const onLoadTreasuryReport = async (e) => {
    e.preventDefault();
    if (!String(projectId).trim()) {
      setMessage("Enter a project ID.");
      return;
    }
    try {
      const { data } = await fetchProjectTreasuryReport(projectId.trim());
      setTreasuryReport(data);
      setMessage("");
    } catch (err) {
      setTreasuryReport(null);
      setMessage(err.response?.data?.detail || "Failed to load treasury report.");
    }
  };

  const filteredAuditLogs = auditLogs.filter((log) => {
    const keyword = auditSearch.trim().toLowerCase();
    if (!keyword) return true;
    return (
      String(log.action_type || "").toLowerCase().includes(keyword) ||
      String(log.target_type || "").toLowerCase().includes(keyword) ||
      String(log.target_id || "").toLowerCase().includes(keyword)
    );
  });

  return (
    <div className="page">
      <h2>Admin Operations</h2>
      {message && <p className="msg">{message}</p>}
      <div className="grid-2">
        <div className="card stack" style={{ padding: 14 }}>
          <h3>Project Fund Ledger</h3>
          <form className="stack" onSubmit={onLoadFundLedger}>
            <input value={projectId} onChange={(e) => setProjectId(e.target.value)} placeholder="Project ID" />
            <button type="submit">Load Ledger</button>
          </form>
          <ul className="list">
            {fundLedger.map((l) => (
              <li className="list-item" key={l.id}>
                <span>
                  {l.type} <span className={`badge badge-${l.direction}`}>{l.direction}</span>
                </span>
                <span>
                  {l.amount} ({l.balance_before} → {l.balance_after})
                </span>
              </li>
            ))}
          </ul>
          <h4 style={{ marginTop: 16 }}>Treasury (redeemed shares)</h4>
          <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>
            Snapshot from treasury holding, current NAV, and redemption ledger lines.
          </p>
          <form className="stack" onSubmit={onLoadTreasuryReport}>
            <button type="submit" className="btn-secondary">
              Load treasury report
            </button>
          </form>
          {treasuryReport && (
            <dl className="stack" style={{ marginTop: 10, fontSize: 14 }}>
              <dt>Project</dt>
              <dd>{treasuryReport.project_code || treasuryReport.project_id}</dd>
              <dt>Treasury shares</dt>
              <dd>{treasuryReport.treasury_shares}</dd>
              <dt>Investor shares outstanding</dt>
              <dd>{treasuryReport.investor_shares_outstanding}</dd>
              <dt>NAV / share (BDT)</dt>
              <dd>{treasuryReport.nav_per_share_bdt}</dd>
              <dt>Treasury notional (BDT)</dt>
              <dd>{treasuryReport.treasury_notional_bdt}</dd>
              <dt>Ledger: redemption events / shares sum</dt>
              <dd>
                {treasuryReport.ledger_redemption_events} / {treasuryReport.ledger_redemption_shares_sum}
              </dd>
            </dl>
          )}
        </div>
      </div>

      <div className="card" style={{ padding: 14 }}>
        <h3>Admin Audit Logs</h3>
        <input
          style={{ marginBottom: 10 }}
          placeholder="Search action / target / id"
          value={auditSearch}
          onChange={(e) => setAuditSearch(e.target.value)}
        />
        <ul className="list">
          {filteredAuditLogs.slice(0, 50).map((log) => (
            <li className="list-item" key={log.id}>
              {log.action_type} on {log.target_type} ({log.target_id || "n/a"})
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
